module.exports = __webpack_public_path__ + "static/media/BarcodeFont.b98bc934.ttf";